'use client';
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function styles(param) {
    var fn = param.fn, palette = param.palette;
    var _fn_deriveStates = fn.deriveStates(palette.button.secondary, "info"), hover = _fn_deriveStates.hover, active = _fn_deriveStates.active;
    return _extends({}, fn.transition(), {
        display: "flex",
        alignItems: "center",
        cursor: "pointer",
        padding: "0.5rem",
        marginRight: "0.5rem",
        color: palette.text.tertiary,
        borderRadius: fn.borderRadius()
    }, fn.focusRing({
        color: palette.border.element
    }), {
        "&:hover": {
            backgroundColor: hover
        },
        "&:active": {
            backgroundColor: active,
            color: palette.text.onColor
        }
    });
}

export { styles as default };
